// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CreateQuoteApiParameter, GetQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";

const quotesUrl = "/api/v1/quotes";

export async function createQuote(createQuoteParameter: any): Promise<ServiceResult<QuoteModel>> {
    const customQuotesUrl =
        // eslint-disable-next-line no-prototype-builtins
        createQuoteParameter?.hasOwnProperty("jobNumber") && createQuoteParameter["jobNumber"] !== undefined
            ? `${quotesUrl}?jobNumber=${createQuoteParameter["jobNumber"]}`
            : quotesUrl;
    try {
        const quote = await post<CreateQuoteApiParameter, QuoteModel>(customQuotesUrl, createQuoteParameter);
        return {
            successful: true,
            result: quote,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

// XNG-Change: pass newParameter for the api
export async function getQuote(parameter: any) {
    const { quoteId, ...newParameter } = parameter;
    const quote = await get<QuoteModel>(`${quotesUrl}/${parameter.quoteId}`, newParameter);
    cleanQuote(quote);
    return quote;
}
function cleanQuote(quote: QuoteModel) {
    quote.orderDate = quote.orderDate ? new Date(quote.orderDate) : null;
    quote.expirationDate = quote.expirationDate ? new Date(quote.expirationDate) : null;
    quote.cartLines = quote.quoteLineCollection;
    quote.messageCollection?.forEach(message => {
        if (message.createdDate) {
            message.createdDate = new Date(message.createdDate);
        }
    });
}
